import BasePage from './BasePage';
import { connect } from 'react-redux';
import {setModalContent} from '../actionCreators';
import Menu from '../components/Menu';
import Modal from '../components/Modal';
import $ from 'jquery';

class EditSigning extends BasePage {

    loadOnConstructor(){
	this.getSigningInterface = this.getSigningInterface.bind(this);
	this.cancelButton = this.cancelButton.bind(this);
	this.saveButton = this.saveButton.bind(this);
	this.updateSigningCallback = this.updateSigningCallback.bind(this);
	this.newSigningCallback = this.newSigningCallback.bind(this);
	this.handleChange = this.handleChange.bind(this);
	this.parseResponse = this.parseResponse.bind(this);
	this.stringBackToStringFront = this.stringBackToStringFront.bind(this);

	const {signing_id} = this.getUrlParams();
	if(signing_id !== undefined){
		this.state = {action: 'modify'};
		this.getSigningInterface(signing_id);
	}else{
		this.state = {action: 'new'};
		this.getSigningInterface();
	}
    }

    getSigningInterface(signingId){
	const api = this.getApi();
	api.getEditSigningInterface(signingId, this.parseResponse);
    }

    parseResponse(response){
	if(response.hasOwnProperty('auth') && response.auth === false){
		this.navigateTo('/login');
		return;
	}

	if(response.status === 'OK'){
		if(this.state.action === 'modify'){
			response.signing.sign_date = this.stringBackToStringFront(response.signing.sign_date);
			response.signing.creation_date = this.stringBackToStringFront(response.signing.creation_date);
			response.signing.modification_date = this.stringBackToStringFront(response.signing.modification_date);

			this.setState(prevState => {
				return {
					...prevState,
					signing: response.signing,
					i18n: response.i18n
				}
			});
		}else{
			this.setState(prevState => {
				return {
					...prevState,
					users: response.users,
					i18n: response.i18n
				}
			});
		}
	}else{
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad(response.message)],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true }
			]
		});

		$("#exampleModal").modal('toggle');
		return;
	}
    }

    stringBackToStringFront(originalStr){
	const objDate = new Date(originalStr);

	return objDate.getUTCFullYear() + "-" +
		("0" + (objDate.getUTCMonth()+1)).slice(-2) + "-" +
		("0" + objDate.getUTCDate()).slice(-2) + " " +
		("0" + objDate.getUTCHours()).slice(-2) + ":" +
		("0" + objDate.getUTCMinutes()).slice(-2) + ":" +
		("0" + objDate.getUTCSeconds()).slice(-2);
    }

    cancelButton(){
	this.goBack();
    }

    saveButton(){

	let failedValidators = {};

	if(this.state.action === 'new' && $('#user').val() === '0'){
		failedValidators.user = this.getTrad('selectUserToInsertSigning');
	}

	if($('#sign_date').val() === ''){
		failedValidators.signDate = this.getTrad('fillSigningDate');
	}else if(!$('#sign_date').val().match(/^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}$/)){
		failedValidators.signDateFormat = this.getTrad('fillSigningDateFormat');
	}

	if(Object.keys(failedValidators).length !== 0){
		let message = [];
		for (let m in failedValidators){
			message.push(failedValidators[m]);
		}
		this.props.setModalContent({
			title: 'Debe completar los datos obligatorios',
			body: message,
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true }
			]
		});

		$("#exampleModal").modal('toggle');
		return;
	}

	const api = this.getApi();

	if(this.state.action === 'modify'){
	    	api.updateSigning(this.state.signing,this.updateSigningCallback);
	}else{
	    	api.newSigning(this.state.signing,this.newSigningCallback);
	}
    }

    updateSigningCallback(response){
	    if(response.status === 'OK'){
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: ['El fichaje ha sido modificado satisfactoriamente.'],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			    ]
		    });

		    $("#exampleModal").modal('toggle');
	    }else{
		    this.props.setModalContent({
			    title: this.getTrad('messageFromServer'),
			    body: [this.getTrad(response.message)],
			    buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true}
			    ]
		    });

		    $("#exampleModal").modal('toggle');

	    }
    }

    newSigningCallback(response){
	if(response.status !== 'OK'){

		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad(response.message)],
			buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			]
		});

		$("#exampleModal").modal('toggle');

	}else{
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: ['El fichaje ha sido creado satisfactoriamente.'],
			buttons: [
			    {shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack}
			]
		});

		$("#exampleModal").modal('toggle');
	}
    }

    handleChange(event) {

	let signingMod = this.state.signing?this.state.signing:{};
	signingMod[event.target.name] = event.target.value;

	this.setState(prevState => {
		return {
		...prevState,
		signing: signingMod
	}});
    }

    render() {
        return (
            <div className="container">
            	<Menu />
                <h3>{this.state.action === 'new'?this.getTrad('signingInsertion'):this.getTrad('signingEdition')}</h3>
                <div className="row mt-4">
			<div className="col-12">
			
			{(this.state.signing || this.state.action === 'new')?
				<form>
				  {this.state.action === 'new'?

				  <div className="form-group">
				    <label htmlFor="user">Usuario</label>
				    <select className="form-control" id="user" name="user" defaultValue={this.state.signing !== undefined && this.state.signing.user !== undefined?this.state.signing.user._id:''} 
				  	onChange={this.handleChange} >
				  		<option value='0'>Seleccione un usuario</option>
						{this.state.users?this.state.users.map((user,idx) => {
							return <option key={'opt-user_'+idx} value={user._id}>{user.name+' '+user.lastname}</option>
						}):''}
				    </select>
				  </div>
				  :
				  <div className="form-group">
				  	<div className="row">
				  		<div className="col-4">
				    			<label>Usuario</label>
				    		</div>
				  		<div className="col-8 font-weight-bold">
				    			<label>{this.state.signing?this.state.signing.user.name+' '+this.state.signing.user.lastname:''}</label>
				    		</div>
				    	</div>
				    	<div className="row">
						<div className="col-4">
							<label>{this.getTrad('creationDate')}</label>
						</div>
						<div className="col-8 font-weight-bold">
							{this.state.signing?this.state.signing.creation_date:''}
						</div>
				    	</div>
				    	<div className="row">
						<div className="col-4">
							<label>{this.getTrad('modificationDate')}</label>
						</div>
						<div className="col-8 font-weight-bold">
							{this.state.signing?this.state.signing.modification_date:''}
						</div>
				    	</div>
				  </div>
				  }
				  <div className="form-group">
				    <label htmlFor="sign_date">Fecha fichaje</label>
				    <input type="text" className="form-control" id="sign_date" name="sign_date"
				    defaultValue={this.state.signing?this.state.signing.sign_date:''} onChange={this.handleChange} />
				  </div>
				  <div className="d-flex justify-content-between align-items-center mb-2">
					  <button type="button" className="btn btn-primary" onClick={this.saveButton}>Guardar</button>
					  <button type="button" className="btn btn-secondary" onClick={this.cancelButton}>Cancelar</button>
				  </div>
				</form>

			:<span>El fichaje no existe</span>}

			</div>
                </div>

		<Modal />
            </div>
        );
    }

    cursorPointer = {
	cursor: 'pointer',
	width: '100%',
	background: '#CCC',
	padding:'3px',
	fontWeight: 'bold',
	textAlign: 'center'
    }
}

const mapStateToProps = state => {
    return {
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
	    dispatch(setModalContent(modalContent));
	}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSigning)
